import { render, staticRenderFns } from "./weihnachtskarten.vue?vue&type=template&id=1ee9ce64&"
import script from "./weihnachtskarten.vue?vue&type=script&lang=js&"
export * from "./weihnachtskarten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports